var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRank2St = function SvgIconRank2St(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-rank-2st_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__b)",
    d: "M9.516 29.536c1.98.813 3.548 2.125 4.509 3.612.2.311-.103 1.05-.465 1.13-1.728.383-3.764.215-5.745-.598s-3.549-2.125-4.51-3.611c-.2-.312.103-1.05.465-1.131 1.728-.383 3.765-.215 5.746.598"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__c)",
    d: "M9.516 29.536c1.98.813 3.548 2.125 4.509 3.612.2.311-.103 1.05-.465 1.13-1.728.383-3.764.215-5.745-.598s-3.549-2.125-4.51-3.611c-.2-.312.103-1.05.465-1.131 1.728-.383 3.765-.215 5.746.598"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__d)",
    d: "M10.523 26.724c1.94 1.538 3.261 3.497 3.852 5.455.124.41-.45 1.134-.877 1.107-2.042-.128-4.251-.966-6.191-2.504s-3.261-3.497-3.852-5.455c-.124-.41.45-1.134.877-1.108 2.042.129 4.251.967 6.191 2.505"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__e)",
    d: "M10.523 26.724c1.94 1.538 3.261 3.497 3.852 5.455.124.41-.45 1.134-.877 1.107-2.042-.128-4.251-.966-6.191-2.504s-3.261-3.497-3.852-5.455c-.124-.41.45-1.134.877-1.108 2.042.129 4.251.967 6.191 2.505"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__f)",
    d: "M12.482 22.398c1.7 2.61 2.493 5.474 2.415 8.047-.016.539-.99 1.173-1.489.97-2.384-.969-4.684-2.852-6.384-5.461S4.53 20.48 4.608 17.907c.016-.539.99-1.173 1.49-.97 2.384.969 4.684 2.852 6.384 5.461"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__g)",
    d: "M4.898 20.935c.365 1.685 1.07 3.403 2.126 5.022 1.7 2.61 4 4.492 6.384 5.461.5.203 1.473-.431 1.489-.97.078-2.573-.716-5.437-2.416-8.047a15.2 15.2 0 0 0-3.522-3.815z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__h)",
    d: "M30.484 29.536c-1.981.813-3.549 2.125-4.51 3.612-.2.311.103 1.05.465 1.13 1.728.383 3.765.215 5.746-.598s3.548-2.125 4.509-3.611c.201-.312-.102-1.05-.464-1.131-1.728-.383-3.765-.215-5.746.598"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__i)",
    d: "M30.484 29.536c-1.981.813-3.549 2.125-4.51 3.612-.2.311.103 1.05.465 1.13 1.728.383 3.765.215 5.746-.598s3.548-2.125 4.509-3.611c.201-.312-.102-1.05-.464-1.131-1.728-.383-3.765-.215-5.746.598"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__j)",
    d: "M29.476 26.724c-1.94 1.538-3.26 3.497-3.852 5.455-.124.41.45 1.134.878 1.107 2.042-.128 4.25-.966 6.19-2.504s3.262-3.497 3.853-5.455c.124-.41-.45-1.134-.878-1.108-2.042.129-4.25.967-6.19 2.505"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__k)",
    d: "M29.476 26.724c-1.94 1.538-3.26 3.497-3.852 5.455-.124.41.45 1.134.878 1.107 2.042-.128 4.25-.966 6.19-2.504s3.262-3.497 3.853-5.455c.124-.41-.45-1.134-.878-1.108-2.042.129-4.25.967-6.19 2.505"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__l)",
    d: "M27.518 22.398c-1.7 2.61-2.493 5.474-2.416 8.047.017.539.99 1.173 1.49.97 2.384-.969 4.684-2.852 6.384-5.461s2.493-5.474 2.415-8.047c-.016-.539-.99-1.173-1.489-.97-2.384.969-4.684 2.852-6.384 5.461"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__m)",
    d: "M35.101 20.935c-.365 1.685-1.07 3.403-2.125 5.022-1.7 2.61-4 4.492-6.385 5.461-.5.203-1.472-.431-1.489-.97-.077-2.573.716-5.437 2.416-8.047a15.2 15.2 0 0 1 3.522-3.815z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__n)",
    d: "M20 40c6.888 0 12.473-5.584 12.473-12.473 0-6.888-5.585-12.472-12.473-12.472S7.527 20.639 7.527 27.527C7.527 34.416 13.111 40 20 40"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__o)",
    d: "M20 37.47c5.49 0 9.942-4.452 9.942-9.942S25.49 17.586 20 17.586c-5.49 0-9.941 4.45-9.941 9.942 0 5.49 4.45 9.941 9.941 9.941"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__p)",
    d: "M20 36.062a8.535 8.535 0 1 0 0-17.07 8.535 8.535 0 0 0 0 17.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__q)",
    d: "M7.527 27.528C7.527 34.416 13.111 40 20 40c6.888 0 12.473-5.584 12.473-12.472l-.002-.145H7.529z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__r)",
    d: "M23.498 39.505a12.5 12.5 0 0 0 8.341-8.044l-6.074-6.074-1.37.067-3.696-3.696L16.194 32.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__s)",
    d: "m25.114 24.815-2.446-.59a.94.94 0 0 1-.557-.388l-1.41-2.084a.93.93 0 0 0-.701-.41.93.93 0 0 0-.7.41l-1.41 2.084a.94.94 0 0 1-.558.387l-2.446.591a.94.94 0 0 0-.52 1.49l1.546 1.986a.94.94 0 0 1 .195.65l-.193 2.509a.94.94 0 0 0 1.256.955l2.366-.857a.94.94 0 0 1 .464-.044.94.94 0 0 1 .464.044l2.366.857a.94.94 0 0 0 1.257-.955l-.194-2.51a.94.94 0 0 1 .195-.65l1.547-1.984a.94.94 0 0 0-.52-1.491"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__t)",
    d: "m20.464 31.548 2.366.857a.94.94 0 0 0 1.257-.955l-.194-2.51a.94.94 0 0 1 .195-.65l1.547-1.984a.94.94 0 0 0-.52-1.491l-2.447-.59a.94.94 0 0 1-.557-.388l-1.41-2.084a.93.93 0 0 0-.701-.41v10.16a.94.94 0 0 1 .464.045"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__u)",
    d: "m25.114 24.817-2.446-.591a1 1 0 0 1-.237-.093l-6.235 8.065c.244.236.613.34.974.21l2.366-.858a.94.94 0 0 1 .464-.044.94.94 0 0 1 .463.044l2.366.857a.94.94 0 0 0 1.257-.956l-.194-2.509a.94.94 0 0 1 .196-.65l1.547-1.984a.94.94 0 0 0-.52-1.491"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__v)",
    d: "m14.886 24.817 2.446-.591a1 1 0 0 0 .236-.093l6.236 8.065a.94.94 0 0 1-.974.21l-2.366-.858a.94.94 0 0 0-.464-.044.94.94 0 0 0-.464.044l-2.366.857a.94.94 0 0 1-1.257-.956l.194-2.509a.94.94 0 0 0-.195-.65l-1.547-1.984a.94.94 0 0 1 .52-1.491"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__w)",
    d: "M14.235 25.383a.93.93 0 0 0 .13.924l1.547 1.985a.94.94 0 0 1 .195.65l-.194 2.509a.94.94 0 0 0 1.257.955l2.366-.857a.94.94 0 0 1 .464-.044.94.94 0 0 1 .464.044l2.366.857a.94.94 0 0 0 1.257-.955l-.194-2.51a.9.9 0 0 1 .05-.378z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__x)",
    d: "M25.767 25.383a.93.93 0 0 1-.131.924l-1.547 1.985a.94.94 0 0 0-.195.65l.194 2.509a.94.94 0 0 1-1.257.955l-2.366-.857a.94.94 0 0 0-.464-.044.94.94 0 0 0-.464.044l-2.365.857a.94.94 0 0 1-1.258-.955l.194-2.51a.9.9 0 0 0-.05-.378z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__y)",
    d: "m20 15.055-.155.002-1.925 1.925 14.052 14.051c.325-1.112.5-2.288.5-3.506 0-6.888-5.584-12.472-12.472-12.472"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__z)",
    d: "M12.47.258v6.588l7.53 7.53 7.529-7.53V.258z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__A)",
    d: "M12.47.258v2.05l7.504 7.504a.036.036 0 0 0 .05 0l7.505-7.504V.258z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__B)",
    d: "M12.47.258v2.05l7.504 7.504a.036.036 0 0 0 .05 0l7.505-7.504V.258z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__C)",
    d: "M20 10.996c-.31 0-.621-.119-.857-.355L12.47 3.97v2.874l7.53 7.53 7.529-7.53V3.969l-6.672 6.672a1.2 1.2 0 0 1-.857.355"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__D)",
    d: "M20 10.996c-.31 0-.621-.119-.857-.355L12.47 3.97v2.874l7.53 7.53 7.529-7.53V3.969l-6.672 6.672a1.2 1.2 0 0 1-.857.355"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__E)",
    d: "M20 10.996c.31 0 .62-.119.857-.355l6.672-6.672v2.874l-7.53 7.53-7.529-7.53V3.969l6.673 6.672c.236.236.546.355.857.355"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__F)",
    d: "M19.174 12.666 12.767 6.26a1.23 1.23 0 0 0-1.74 1.74L20 16.972l8.973-8.973a1.23 1.23 0 0 0-1.74-1.74l-6.407 6.407a1.17 1.17 0 0 1-1.652 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__G)",
    d: "m11.027 6.273 8.028 8.029a1.336 1.336 0 0 0 1.89 0l8.028-8.029.007-.007-.007-.007a1.23 1.23 0 0 0-1.74 0l-6.407 6.407a1.17 1.17 0 0 1-1.652 0L12.767 6.26a1.23 1.23 0 0 0-1.74 0l-.006.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__H)",
    d: "m20 16.975 6.334-6.334h-3.48l-2.029 2.028a1.17 1.17 0 0 1-1.651 0l-2.028-2.028h-3.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__I)",
    d: "m19.215 16.187.785.784 8.033-8.033h-3.48l-3.728 3.727a1.167 1.167 0 0 1-1.61.038z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__J)",
    d: "M20 17.843a2.941 2.941 0 1 0 0-5.882 2.941 2.941 0 0 0 0 5.882"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__K)",
    d: "M20 16.591a1.686 1.686 0 1 0 0-3.372 1.686 1.686 0 0 0 0 3.372"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-2st_svg__L)",
    d: "M28.667 2.928H11.333a.9.9 0 0 1-.902-.902V.902c0-.498.404-.902.902-.902h17.334c.498 0 .901.404.901.902v1.124a.9.9 0 0 1-.901.902"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__b",
    x1: 7.236,
    x2: 8.654,
    y1: 27.871,
    y2: 31.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__c",
    x1: 6.501,
    x2: 9.603,
    y1: 29.802,
    y2: 32.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__d",
    x1: 5.638,
    x2: 8.61,
    y1: 24.614,
    y2: 28.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__e",
    x1: 6.369,
    x2: 9.194,
    y1: 28.112,
    y2: 28.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__f",
    x1: 9.547,
    x2: 9.855,
    y1: 19.877,
    y2: 26.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__g",
    x1: 9.072,
    x2: 10.919,
    y1: 23.167,
    y2: 25.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__h",
    x1: 32.767,
    x2: 31.349,
    y1: 27.869,
    y2: 31.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__i",
    x1: 33.502,
    x2: 30.4,
    y1: 29.799,
    y2: 32.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__j",
    x1: 34.365,
    x2: 31.393,
    y1: 24.611,
    y2: 28.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__k",
    x1: 33.634,
    x2: 30.809,
    y1: 28.109,
    y2: 28.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__l",
    x1: 30.456,
    x2: 30.148,
    y1: 19.874,
    y2: 26.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__m",
    x1: 30.93,
    x2: 29.084,
    y1: 23.164,
    y2: 25.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__n",
    x1: 12.31,
    x2: 25.464,
    y1: 19.837,
    y2: 32.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__o",
    x1: 26.457,
    x2: 13.355,
    y1: 33.984,
    y2: 20.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__p",
    x1: 13.795,
    x2: 24.008,
    y1: 21.323,
    y2: 31.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__q",
    x1: 20,
    x2: 20,
    y1: 31.177,
    y2: 39.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__r",
    x1: 27.47,
    x2: 17.169,
    y1: 34.012,
    y2: 27.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__s",
    x1: 17.402,
    x2: 22.087,
    y1: 25.154,
    y2: 29.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__t",
    x1: 22.807,
    x2: 16.332,
    y1: 26.432,
    y2: 29.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#678D98",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#678D98",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__u",
    x1: 21.116,
    x2: 17.571,
    y1: 28.732,
    y2: 27.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#678D98",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#678D98",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__v",
    x1: 18.883,
    x2: 22.429,
    y1: 28.732,
    y2: 27.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#678D98",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#678D98",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__w",
    x1: 18.962,
    x2: 21.241,
    y1: 28.909,
    y2: 25.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#678D98",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#678D98",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__x",
    x1: 20.863,
    x2: 20.673,
    y1: 28.446,
    y2: 24.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#678D98",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#678D98",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__y",
    x1: 26.146,
    x2: 21.336,
    y1: 22.258,
    y2: 13.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__z",
    x1: 20.557,
    x2: 23.655,
    y1: 4.442,
    y2: 9.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__A",
    x1: 17.467,
    x2: 27.088,
    y1: -1.621,
    y2: 9.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__B",
    x1: 20,
    x2: 20,
    y1: 5.212,
    y2: 2.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0182FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#017FF3",
    stopOpacity: 0.126
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#0176DB",
    stopOpacity: 0.331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#0268B4",
    stopOpacity: 0.588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#02547E",
    stopOpacity: 0.886
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__C",
    x1: 15.424,
    x2: 25.044,
    y1: 0.158,
    y2: 11.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__D",
    x1: 22.98,
    x2: 24.319,
    y1: 8.386,
    y2: 9.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0182FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#017FF3",
    stopOpacity: 0.126
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#0176DB",
    stopOpacity: 0.331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#0268B4",
    stopOpacity: 0.588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#02547E",
    stopOpacity: 0.886
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__E",
    x1: 17.02,
    x2: 15.681,
    y1: 8.386,
    y2: 9.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0182FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#017FF3",
    stopOpacity: 0.126
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#0176DB",
    stopOpacity: 0.331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#0268B4",
    stopOpacity: 0.588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#02547E",
    stopOpacity: 0.886
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__F",
    x1: 26.799,
    x2: 10.716,
    y1: 13.928,
    y2: -2.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__G",
    x1: 20,
    x2: 20,
    y1: 6.403,
    y2: 17.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__H",
    x1: 20,
    x2: 20,
    y1: 12.784,
    y2: 16.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__I",
    x1: 23.707,
    x2: 21.511,
    y1: 10.736,
    y2: 12.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__J",
    x1: 18.313,
    x2: 22.473,
    y1: 13.216,
    y2: 17.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__K",
    x1: 21.196,
    x2: 19.137,
    y1: 16.101,
    y2: 14.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-2st_svg__L",
    x1: 20,
    x2: 20,
    y1: 0.889,
    y2: 2.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-rank-2st_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgIconRank2St;